import { createContext, useContext } from 'react';
import { MultiStepDialogContextValue } from './types';

export const MultiStepDialogContext =
  createContext<MultiStepDialogContextValue | null>(null);

export const useMultiStepDialog = () => {
  const ctx = useContext(MultiStepDialogContext);

  if (!ctx) {
    throw new Error('useMultiStepDialog must be used within MultiStepDialog');
  }

  return ctx;
};
